import { FC, useMemo } from 'react';

// Third-party
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';

// Assets
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { ReactComponent as NoTasks } from '../static/ic_no_tasks.svg';

// Types
import { TSubmissionBlockWrapper } from '../type';

const SubmissionBlockWrapper: FC<TSubmissionBlockWrapper> = ({
  selectedSubmission,
  children,
}) => {
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  const isDisplaySubmission = useMemo(() => (
    selectedSubmission && 'id' in selectedSubmission && selectedSubmission?.id)
            || (selectedSubmission && 'tasklistId' in selectedSubmission
                && selectedSubmission?.tasklistId), [selectedSubmission]);

  return (
    <Card sx={{
      mt: 3,
      height: '49vh',
      overflow: 'auto',
      position: 'relative',
      ...(isMobile && {
        backgroundColor: 'unset',
        height: 'auto',
        minHeight: '49vh',
      }),
    }}
    >
      {isDisplaySubmission ? (
        children
      ) : (
        <Box
          marginX="auto"
          marginTop={10}
          sx={{
            width: 200,
            height: 200,
            lineHeight: 0,
            borderRadius: '50%',
            bgcolor: 'background.neutral',
          }}
        >
          <SvgIcon
            sx={{
              width: '100%',
              height: '100%',
            }}
            inheritViewBox
            component={NoTasks}
          />
        </Box>
      )}
    </Card>
  );
};

export {
  SubmissionBlockWrapper,
};
